export default __webpack_public_path__ + "static/media/trr-drink-specialtycoffee-strawberryupsidedownlatte.898edb03.png";